import type { State } from './types';

export interface Store<S = State> {
  get(): S;
  set(s: S): void;
  subscribe(fn: (s: S) => void): () => void;
}

export function createStore<S = State>(initial: S): Store<S> {
  let state = initial;
  const subs = new Set<(s: S) => void>();

  return {
    get: () => state,
    set: (next) => {
      if (next === state) return;
      state = next;
      for (const fn of subs) fn(state);
    },
    subscribe: (fn) => {
      subs.add(fn);
      return () => {
        subs.delete(fn);
      };
    }
  };
}
